export default class GroupColorChange {

	constructor() {

		this.settings = {
			sectionSelector: '.page__content > .wp-block-group[class*="has-"][class*="-background-color"]',
			observerOptions: {
				root: null,
				rootMargin: '-45% 0px -45% 0px',
				threshold: 0,
			},
		};

		this.sections = [];
		this.observer = null;
		this.isTicking = false;
		this.defaultBodyColor = '';
		this.activeColorSlug = '';

	}

	init() {

		this.sections = Array.from( document.querySelectorAll( this.settings.sectionSelector ) );

		if ( this.sections.length === 0 ) {
			return;
		}

		this.defaultBodyColor = window.getComputedStyle( document.body ).backgroundColor;

		this.bindScrollSync();

		if ( typeof window.IntersectionObserver !== 'undefined' ) {
			this.observer = new IntersectionObserver(
				() => this.queueSync(),
				this.settings.observerOptions
			);

			this.sections.forEach( ( section ) => {
				this.observer.observe( section );
			} );
		}

		this.syncBodyColor();

	}

	bindScrollSync() {

		window.addEventListener( 'scroll', () => this.queueSync(), { passive: true } );
		window.addEventListener( 'resize', () => this.queueSync() );

	}

	queueSync() {

		if ( this.isTicking ) {
			return;
		}

		this.isTicking = true;

		window.requestAnimationFrame( () => {
			this.syncBodyColor();
			this.isTicking = false;
		} );

	}

	syncBodyColor() {

		const activationPoint = window.innerHeight * 0.35;
		let activeSection = null;

		this.sections.forEach( ( section ) => {
			const rect = section.getBoundingClientRect();

			if ( rect.top <= activationPoint && rect.bottom > activationPoint ) {
				activeSection = section;
			}
		} );

		if ( ! activeSection ) {
			for ( let i = this.sections.length - 1; i >= 0; i-- ) {
				const rect = this.sections[i].getBoundingClientRect();

				if ( rect.top <= activationPoint ) {
					activeSection = this.sections[i];
					break;
				}
			}
		}

		this.updateBodyColor( activeSection );

	}

	updateBodyColor( section ) {

		const colorSlug = section ? this.getColorSlugFromClassList( section.classList ) : '';

		if ( colorSlug === this.activeColorSlug ) {
			return;
		}

		if ( ! colorSlug ) {
			document.body.style.backgroundColor = this.defaultBodyColor;
			this.activeColorSlug = '';
			return;
		}

		document.body.style.backgroundColor = `var(--wp--preset--color--${ colorSlug })`;
		this.activeColorSlug = colorSlug;

	}

	getColorSlugFromClassList( classList ) {

		const backgroundColorClass = Array.from( classList ).find( ( className ) => className.endsWith( '-background-color' ) && className.startsWith( 'has-' ) );

		if ( ! backgroundColorClass ) {
			return '';
		}

		return backgroundColorClass.replace( /^has-/, '' ).replace( /-background-color$/, '' );

	}

}
